import React, { useCallback } from 'react'
import ListItem from '../list-item'
import CustomAnchor from '../custom-anchor'
import PageLoader from '../page-loader'

const References = ({
    references = [],
    loading,
    showToaster,
    onReferenceClick
}) => {
    const handleReferenceClick = useCallback((referenceData) => {
        try {
            onReferenceClick && onReferenceClick(referenceData)
        } catch (error) {
            showToaster(error?.message || "Something went wrong", false)
        }
    }, [showToaster, onReferenceClick])
  return (
    <div className={`references-container ${loading ? 'loading' : 'loaded'}`}>
        <div className='references-header'>
            <img src="/images/icon/spec.svg" alt="" className='references-icon'/>
            <p className='references-title'>References</p>
        </div>
        {loading && <PageLoader/>}
        <div className='references-list'>
            {!!references?.length && (
                <>
                    {references.map((referenceData, index) => (
                        <div key={referenceData?.id || `referenceData-${index}`} className='reference'>
                            <ListItem
                                tags={[{id: 'refrence-page', displayName: `Page ${referenceData.pdfPageNumber}`}]}
                                title={<CustomAnchor onClick={() => handleReferenceClick(referenceData)}>{referenceData?.title || `${referenceData.pdfFileName}-`}</CustomAnchor>}
                            />
                        </div>
                    ))}
                </>
            )}
        </div>
    </div>
  )
}

export default References